export function formatHtml(str: string): string {
    let indentLevel = 0;

    const formattedStr = str
        .replace(/>\s*</g, '><')
        .replace(/</g, '\n<')
        .split('\n')
        .map((line) => {
            if (!line.trim()) return '';
            if (line.match(/^<\/\w/)) {
                indentLevel = Math.max(indentLevel - 1, 0);
            }

            const indent = '\t'.repeat(indentLevel);
            const formattedLine = indent + line.trim();

            if (line.match(/^<\w[^>]*[^/]>$/) && !line.includes('/>')) {
                indentLevel += 1;
            }

            return formattedLine;
        })
        .filter(Boolean)
        .join('\n')
        .trim();

    const escapedStr = formattedStr.replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return `<pre><code class="language-html">${escapedStr}</code></pre>`;
}
